var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#e3e3e3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220-80v-66.67h226.67V-320H360q-83 0-141.5-58.5T160-520q0-60 33-110.5t89-73.5q9-75 65.5-125.5T480-880q76 0 132.5 50.5T678-704q56 23 89 73.5T800-520q0 83-58.5 141.5T600-320h-86.67v173.33h233.34V-80H220Zm140-306.67h240q55.56 0 94.44-38.89 38.89-38.88 38.89-94.44 0-40-22.83-73t-59.17-49L616-657.33 611.33-696q-6.66-50.33-43.95-83.83-37.29-33.5-87.38-33.5-50.09 0-87.38 33.5-37.29 33.5-43.95 83.83L344-657.33 308.67-642q-36.34 16-59.17 49.15t-22.83 72.93q0 55.25 38.89 94.25 38.88 39 94.44 39ZM480-600Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.3fa381e5e8f2d1f1ce99e5f21fe8d79c.svg";
export { ForwardRef as ReactComponent };